import { Navigate } from "react-router-dom";
import { useAuth } from "@/components/AuthProvider";
import { ShieldAlert } from "lucide-react";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="h-screen w-full grid place-items-center">
        <div className="text-sm text-muted-foreground">Cargando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) {
    return (
      <div className="h-screen w-full grid place-items-center p-6">
        <div className="max-w-md text-center space-y-3" data-testid="admin-access-denied">
          <div className="mx-auto h-14 w-14 rounded-full bg-red-500/10 grid place-items-center">
            <ShieldAlert className="h-7 w-7 text-red-500" />
          </div>
          <h1 className="text-2xl font-semibold">Acceso restringido</h1>
          <p className="text-sm text-muted-foreground">
            Este panel es exclusivo para administradores del sistema.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
